import { Concern } from '@services';

// action strings
export const ADD_CONCERN = 'ADD_CONCERN';
export const REMOVE_CONCERN = 'REMOVE_CONCERN';
export const CHANGE_CONCERN = 'CHANGE_CONCERN';
export const RESET_CONCERNS = 'RESET_CONCERNS';

export interface AddConcern {
  type: typeof ADD_CONCERN;
}

export interface RemoveConcern {
  type: typeof REMOVE_CONCERN;
  index: number;
}

export interface ChangeConcern {
  type: typeof CHANGE_CONCERN;
  concern: Concern;
  index: number;
}

export interface ResetConcern {
  type: typeof RESET_CONCERNS;
}

export type ConcernActions = AddConcern | RemoveConcern | ChangeConcern | ResetConcern;
